import { useCallback, useState } from 'react'
import { useAuth } from '../auth/useAuth'

const useInlineActions = () => {
  const { user } = useAuth()
  const [referencesModal, setReferencesModal] = useState(null)

  // Utility functions for actions
  const validateUserPermission = (user, action) => {
    // Basic permission validation - can be extended as needed
    switch (action) {
      case 'share':
        return true // Available to all users
      case 'references':
        return true // Available to all users (but may show different content)
      default:
        return false
    }
  }

  const openShareModal = useCallback((data) => {
    // Implementation for sharing
    // TODO: Implement actual sharing modal
    if (navigator.share) {
      navigator.share(data)
    }
  }, [])

  const fetchReferences = useCallback(
    async (sentenceUUID) => {
      // Fetch references from API
      try {
        const response = await fetch(`/api/references/${sentenceUUID}`, {
          headers: user
            ? {
                Authorization: `Bearer ${user.access_token}`,
              }
            : {},
        })

        if (!response.ok) {
          throw new Error('Failed to fetch references')
        }

        return await response.json()
      } catch (error) {
        // Error fetching references - return empty array
        return []
      }
    },
    [user]
  )

  const handleComponentAction = useCallback(
    (action, data) => {
      // Validate user permissions
      if (!validateUserPermission(user, action)) {
        console.warn('User lacks permission for action:', action)
        return
      }

      switch (action) {
        case 'share':
          openShareModal(data)
          break

        // Option 2: Clickable Sentence - Show References
        case 'references':
          // Show references for clicked sentence
          setReferencesModal({
            sentenceUUID: data.sentenceUUID,
            loading: true,
          })
          // Fetch references from API
          fetchReferences(data.sentenceUUID).then((refs) => {
            setReferencesModal({
              sentenceUUID: data.sentenceUUID,
              references: refs,
              loading: false,
            })
          })
          break

        default:
          // Unknown action - ignore silently
          break
      }
    },
    [user, fetchReferences, openShareModal]
  )

  const closeReferencesModal = useCallback(() => {
    setReferencesModal(null)
  }, [])

  return {
    handleComponentAction,
    referencesModal,
    closeReferencesModal,
  }
}

export default useInlineActions
